var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.customClass,style:({ fill: _vm.color, width: '24px', height: '24px' }),attrs:{"src":_vm.iconPath,"alt":"svg icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }